export default ['RegisterVisit', 'RegisterSchedule'];
